
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';

export const PaymentSettingsLoader: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Méthodes de Paiement</CardTitle>
        <CardDescription>Chargement des paramètres de paiement...</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-40 flex items-center justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-custom-primary"></div>
        </div>
      </CardContent>
    </Card>
  );
};
